module.exports = __webpack_public_path__ + "img/thumbnail.59b5eefa.png";